var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 621,
    viewBox: "0 0 621 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 310.5C68 177.123 176.123 69 309.5 69C442.877 69 551 177.123 551 310.5C551 443.877 442.877 552 309.5 552C176.123 552 68 443.877 68 310.5Z",
    stroke: "url(#paint0_linear_2043_351)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136 310.5C136 214.679 213.679 137 309.5 137C405.321 137 483 214.679 483 310.5C483 406.321 405.321 484 309.5 484C213.679 484 136 406.321 136 310.5Z",
    stroke: "url(#paint1_linear_2043_351)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 310.5C1.00002 139.568 139.568 0.999981 310.5 0.999966C481.432 0.999951 620 139.568 620 310.5C620 481.432 481.432 620 310.5 620C139.568 620 1.00005 481.432 1.00003 310.5Z",
    stroke: "url(#paint2_linear_2043_351)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2043_351",
    x1: 309.5,
    y1: 433.946,
    x2: 309.5,
    y2: -140.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2043_351",
    x1: 309.5,
    y1: 399.33,
    x2: 309.5,
    y2: -14.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2043_351",
    x1: 243,
    y1: 153,
    x2: 310.5,
    y2: -267.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbits);
export default __webpack_public_path__ + "static/media/orbits.00e9a2eb8ebc3ec72de53bc4cdc20034.svg";
export { ForwardRef as ReactComponent };